module.exports = __webpack_public_path__ + "img/pantalla2-4.ebf2d789.png";